import { atom } from "jotai";

export interface HeaderAllMenu {
  isOpen: boolean;
}

export const headerAllMenuAtom = atom<HeaderAllMenu>({
  isOpen: false,
});
